/**
 * Client API pour les endpoints /api/admin/* (avec token JWT en localStorage).
 * Gère automatiquement les 401 (redirection vers /admin/login).
 */
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "mw_admin_token";

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
export const isAuthed = () => !!getToken();

async function request(path, { method = "GET", body, raw = false } = {}) {
  const headers = { "Content-Type": "application/json" };
  const tok = getToken();
  if (tok) headers["Authorization"] = `Bearer ${tok}`;

  const res = await fetch(`${API}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  if (res.status === 401) {
    clearToken();
    if (window.location.pathname.startsWith("/admin") && !window.location.pathname.endsWith("/login")) {
      window.location.href = "/admin/login";
    }
    throw new Error("unauthorized");
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data.detail || `HTTP ${res.status}`);
    err.status = res.status;
    err.detail = data.detail;
    throw err;
  }
  return raw ? res : data;
}

export const adminApi = {
  login: (password) => request("/admin/login", { method: "POST", body: { password } }),
  nowPlayingAll: (bust) => request(`/admin/now-playing-all${bust ? `?t=${bust}&fresh=1` : ""}`),
  validate: (payload) => request("/admin/artwork/validate", { method: "POST", body: payload }),
  reject: (artist, title) =>
    request("/admin/artwork/reject", { method: "POST", body: { artist, title } }),
  history: (status = "") =>
    request(`/admin/artwork/history${status ? `?status=${status}` : ""}`),
  deleteArtwork: (artist, title) =>
    request(`/admin/artwork?artist=${encodeURIComponent(artist)}&title=${encodeURIComponent(title)}`, { method: "DELETE" }),
  suggestions: (artist, title) =>
    request(`/admin/artwork/suggestions?artist=${encodeURIComponent(artist)}&title=${encodeURIComponent(title)}`),
  listRadios: () => request("/admin/radios"),
  upsertRadio: (radio) => request("/admin/radios", { method: "POST", body: radio }),
  deleteRadio: (id) => request(`/admin/radios/${encodeURIComponent(id)}`, { method: "DELETE" }),
  analytics: (range = "7d") => request(`/admin/analytics?range=${range}`),
};
